import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=351a4a68&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=ts"
export * from "./PhoneLogin.vue?vue&type=script&lang=ts"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=351a4a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a4a68",
  null
  
)

export default component.exports